import {RunQueryOutputLegacyData} from 'insights/warehouse/AnalyticsWarehouseTypes';
import cellToString from 'insights/warehouse/cellToString';
import * as ExportUtil from 'util/ExportUtil';
import {JSONValue} from 'util/Types';

function rowToStrings(row: Array<JSONValue>): Array<string> {
  return row.map((cell) => cellToString(cell));
}

export function runQueryOutputRowToTSV(row: Array<JSONValue>): string {
  return ExportUtil.formatRows([rowToStrings(row)], '\t');
}

/**
 * Return raw or resolved query results (runQueryOutput) as TSV string
 */
export default function runQueryOutputToTSV(runQueryOutput: RunQueryOutputLegacyData): string {
  return ExportUtil.formatRows(
    runQueryOutput.rows.map((row) => rowToStrings(row)),
    '\t'
  );
}
